export const THEME_CHANGE_NOTIFICATION_METHOD = '__gl_onThemeUpdated';
